// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1tQ6I","loaderOuter":"PageOverlayLoader_loaderOuter__1ToXy"};